import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="w-full bg-[#0a0a0a] py-8 md:py-16 px-4 border-t-4 border-gray-800" data-id="element-252">
      <div className="max-w-3xl mx-auto" data-id="element-253">
        <div className="bg-[#111] p-6 md:p-12 rounded-lg border-l-8 border-[#c41e3a] shadow-lg" data-id="element-254">
          <p className="text-xs md:text-sm text-[#c41e3a] font-black tracking-widest uppercase mb-3" data-id="element-255">
            ¿Para quién es?
          </p>
          <h2 className="text-2xl md:text-4xl font-black text-white mb-5 leading-tight" data-id="element-256">
            Este método es para vos si…
          </h2>
          <div className="w-12 h-0.5 bg-[#c41e3a] mb-6" data-id="element-257"></div>
          <div className="space-y-3" data-id="element-258">
            {['Estás empezando desde cero y querés hacerlo bien desde el principio', 'Ya cortás pero querés profesionalizar tu técnica', 'Buscás independencia laboral y trabajar por tu cuenta', 'Querés generar ingresos propios con una habilidad real'].map(item => <div key={item} className="flex items-start gap-3 text-gray-200" data-id="element-259">
                <CheckCircleIcon className="w-5 h-5 text-[#c41e3a] flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-260" />
                <span className="text-sm md:text-base font-semibold" data-id="element-261">
                  {item}
                </span>
              </div>)}
          </div>

          {/* CTA secundario */}
          <div className="mt-8 flex flex-col items-start gap-2" data-id="element-262">
            <a href="#pricing" className="cta-primary text-white font-black text-sm md:text-base px-8 py-3 rounded-lg inline-block text-center" aria-label="Quiero empezar ahora" data-id="element-263">
              👉 Quiero empezar ahora
            </a>
            <p className="text-gray-600 text-xs font-semibold" data-id="element-264">
              Acceso inmediato · 100% online
            </p>
          </div>
        </div>
      </div>
    </section>;
}